// Mobile "Loan Actions" trigger is a raw outlined Button; floor its hit area to >=44pt for touch.
export const mobileLoanActionsButtonStyles = {
  minHeight: '44px',
};
